import {IAPIEndPoints} from '../model/Network';

export const APIEndPoint: IAPIEndPoints = {
  cookbook: '/cookbook',
  whistle: '/whistle',
  ebill: '/ebill',
  requestOTP: '/request-otp',
  verifyOTP: '/verify-otp',
  EBills: '/bills',
  BillDetails: '/bill-details',
  UpdateProfile: '/profile',
};

export const getAPIEndPoint = (apiKey: string) =>
  (process.env.NEXT_PUBLIC_API_BASE_URL as string) + APIEndPoint[apiKey];
